import { IFormOptions, IButtonObj } from "./form/form.interface";

export enum UserRolesEnum {
    Administrator = "Administrator",
    StudyAdministrator = "StudyAdministrator",
    SiteAdministrator = "SiteAdministrator",
    Subject = "Subject"
}

export interface IAuthUser {
    UserId?: string;
    UserName?: string;
    Role?: string;
    AdminPasswordReset?: boolean;
    AccessToken?: string;
    RefreshToken?: string;
    AnonymousStudy?: boolean;
}


export interface IPopupFormConfig {
    title: string;
    formOptions: IFormOptions[];
    formData?: any;
    footerButtons?: IButtonObj[];
    panelSize?: { width?: number, height?: number };
    submitButton?: string;
    cancelButton?: string;
    panelVisible?: boolean;
    dragit?: boolean;
    resizeit?: boolean;
}
export interface IUserPopupFormConfig extends IPopupFormConfig {
    preFormOptions?: IFormOptions[];
    postFormOptions?: IFormOptions[];
}

export interface IStudyQuest {
    QuestId: string;
    Description: string;
}

export interface IStudyAdminQuestionnaire extends IStudyQuest {
    Id: string;
    ButtonText: string;
    Order: number;
}

export interface IStudyQuestionnaire extends IStudyAdminQuestionnaire {
    Activate: number;
    Remind: number;
    NotificationTitle: string;
    NotificationBody: string;
    EventTitle?: string;
    EventBody?: string;
}


export interface IQuestResponse {
    Status: string;
    QuestResponseId: string;
    JsonData: IQuestResponseJsonData[];
}

export interface IQuestResponseJsonData {
    order?: number;
    linkId: string;
    text: string;
    variable: string;
    responseType: string;
    response: any;
    responseJSON: any;
}
